'use client'

// src/constants/currency.ts
var ABSOLUTE_FALLBACK_CURRENCY = {
  id: "SAR",
  name: "SAR",
  shortCode: "SAR",
  symbol: "SAR"
};

export {
  ABSOLUTE_FALLBACK_CURRENCY
};
//# sourceMappingURL=chunk-WFHUYKGS.mjs.map